/**Create an authentication header */
const authHeader = () => {
    let user = JSON.parse(sessionStorage.getItem('user'));
    //  console.log(user);
    if (user && user.authdata) {
        return { 'Authorization': 'Basic ' + user.authdata };
    } else {
        return {}
    }

}

export default authHeader